import { last } from 'lodash';
import Footer from 'components/footer/Footer';
import Tabs from 'components/tabs/Tabs';
import modulesMap from 'core/modulesMap';
import { bindEmitterMethod } from 'helpers/bind';
import MainPage from 'navigation/pages/MainPage';
import TabsPage from 'navigation/pages/TabsPage';
class Faq extends MainPage {
    static pageName = 'Faq';
    initialized() {
        super.initialized();
        const detectQuestion = new URLSearchParams(window.location.search).get('qid');
        if (detectQuestion)
            this.goToQuestion(detectQuestion);
    }
    getModulesMap() {
        return {
            ...modulesMap,
            tabs: ['.tabs', Tabs],
            adaptableWrapper: modulesMap.adaptableWrapper,
            footer: ['footer', Footer]
        };
    }
    setTabsHeaderHeight = () => {
        return TabsPage.prototype.setTabsHeaderHeight.call(this);
    };
    resize() {
        return TabsPage.prototype.resize.call(this);
    }
    show() {
        return TabsPage.prototype.show.call(this, ...arguments);
    }
    bindEvents(add) {
        const emitterMethod = bindEmitterMethod(add);
        this.modules.tabs[emitterMethod]('tabChange', (tab) => {
            this.refs.pageTabsCategory.forEach(category => {
                category.classList?.remove('active');
                if (category.dataset.category === tab) {
                    category.classList?.add('active');
                    this.modules.drawer.forEach(drawer => {
                        drawer.resize();
                    });
                }
            });
        });
    }
    shouldRouteInternally(el, pathName) {
        return true;
    }
    async internalRouting(pathName, xhr, requestOptions) {
        const search = last(xhr.responseURL.split('?'));
        const detectQuestion = new URLSearchParams(search).get('qid');
        if (detectQuestion)
            this.goToQuestion(detectQuestion);
    }
    goToQuestion(qid) {
        const accordions = this.refs.faqAccordion;
        const accordion = accordions.find(accordion => accordion.dataset.id === qid);
        const accordionParent = accordion?.parentElement;
        this.modules.tabs.activeTab = this.modules.tabs.refs.tabsLinks.find(link => link.dataset.tab === accordionParent?.dataset.category);
        this.modules.tabs.refs.tabsLinks.forEach(link => link.classList.remove('active'));
        this.modules.tabs.activeTab.classList.add('active');
        this.modules.tabs.emit('tabChange', this.modules.tabs.activeTab.dataset.tab);
        this.modules.tabs.updateTrack(this.modules.tabs.activeTab);
        accordion.firstElementChild?.setAttribute('checked', 'true');
    }
}
export default Faq;
